export const Register = "/register";
export const Login = "/login";
export const Page404 = "/404";
export const Page500 = "/505";
export const Dashboard = "/dashboard";
export const UserProfile = "/profile"; 

export const UserTypeList = "/usertype/list";
export const AddUserType = "/usertype/add";
export const EditUserType = "/usertype/edit";
export const EditUserTypeId = "/usertype/edit/:id";

export const RoomTypeList = "/roomtype/list";
export const AddRoomType = "/roomtype/add";
export const EditRoomType = "/roomtype/edit";
export const EditRoomTypeId = "/roomtype/edit/:id";

export const UserList = "/user/list";
export const AddUser = "/user/add";
export const EditUser = "/user/edit";
export const EditUserId = "/user/edit/:id";
export const ViewPermission = "/user/permission/:id";

export const HotelList = "/hostel/list";
export const AddHotel = "/hostel/add";
export const EditHotel = "/hostel/edit";
export const EditHotelId = "/hostel/edit/:id";
export const ViewHotel = "/hostel/details";
export const ViewHotelId = "/hostel/details/:id";
export const ViewHotelRoom = "/hostel/rooms";
export const ViewHotelRoomId = "/hostel/rooms/:hotelId/:id";

export const VisitorList = "/visitor/list";
export const AddVisitors = "/visitor/add";
export const EditVisitor = "/visitor/Edit";
export const EditVisitorId = "/visitor/edit/:id";
export const ViewVisiterId = "/visitor/details/:id";
export const ViewVisitor = "/visitor/details";

export const ReservationList = "/reservation/list";
export const BulkReservation = "/reservation/bulk";
export const ViewReservation = "/reservation/details";
export const ViewReservationId = "/reservation/details/:id";
export const AddReservation = "/reservation/add";
export const EditReservation = "/reservation/edit";

export const EditReservationId = "/reservation/edit/:id";
export const CheckInCheckOutList = "/reservation/checkIncheckOut";
export const AddHotelReservation = "/reservation/hostel/add";
export const AddHotelReservationId = "/reservation/hostel/add/:id";

export const RoomMaintenance = "/manage-rooms-maintenance";
export const manageHostel = "/manage-hostel";

